export default __webpack_public_path__ + "static/media/ProvisioningPicture_Black.13d06314.png";